import React, { useEffect, useState } from "react";
import { shopApi, useShopAuth } from "../../lib/shopAuth";
import { useI18n } from "../../lib/i18n";
import { ReorderButton } from "../shop-account/ReorderButton";

const productLines = (o) => (o.lines || []).filter((l) => l.product_id && !String(l.product_id).startsWith("__"));

// Bandeau catalogue : remettre la dernière commande du client connecté dans le panier.
export function LastOrderBanner() {
  const { customer } = useShopAuth() || {};
  const { t } = useI18n();
  const [order, setOrder] = useState(null);
  const authed = customer && customer !== false;

  useEffect(() => {
    if (!authed) { setOrder(null); return; }
    shopApi.get("/my-orders")
      .then(({ data }) => setOrder((data || []).find((o) => o.status !== "ANNULEE" && productLines(o).length) || null))
      .catch(() => setOrder(null));
  }, [authed]);

  if (!order) return null;
  const lines = productLines(order);
  const qty = lines.reduce((s, l) => s + (Number(l.quantity) || 0), 0);
  const day = order.created_at ? new Date(order.created_at).toLocaleDateString("fr-CH") : "";
  return (
    <div className="border-b" style={{ background: "rgba(193,160,99,0.08)", borderColor: "rgba(193,160,99,0.25)" }} data-testid="last-order-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-3 flex items-center gap-3 flex-wrap justify-between">
        <div className="min-w-0">
          <p className="font-body text-sm" style={{ color: "#F2ECE4" }}>{t("reorder_banner.title")}</p>
          <p className="text-[11px] truncate" style={{ color: "#A6A29C" }} data-testid="last-order-summary">
            {qty} {qty === 1 ? t("cart.barquette_unit") : t("cart.barquette_plural")}
            {day && ` · ${t("reorder_banner.of")} ${day}`}
            {" · "}{lines.slice(0, 3).map((l) => l.product_name).join(", ")}{lines.length > 3 ? "…" : ""}
          </p>
        </div>
        <ReorderButton lines={lines} testid="last-order-reorder-btn" />
      </div>
    </div>
  );
}
